import { combineReducers } from 'redux'

let state_data = {
    dashboard: false,
    reportHub: false,
    workspace: false,
    support: false,
    settings: false,
    createButton: false
  }

const popoverReducer = (state = state_data, action) => {
    switch (action.type) {
        case "DASHBOARD_POPOVER":
            return action.payload
        case "WORKSPACE_POPOVER":
            return action.payload
        case "COLLABRATION_POPOVER":
            return action.payload
        case "SUPPORT_POPOVER":
            return action.payload
        case "SETTINGS_POPOVER":
            return action.payload
        case "CREATE_POPOVER":
            return action.payload
        case "DEFAULT_POPOVER":
            return action.payload
        default: return state
    }
}


export default popoverReducer;